<script setup>
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import { Bars3Icon, XMarkIcon, ShieldCheckIcon } from '@heroicons/vue/24/outline'

defineProps({
  transparent: {
    type: Boolean,
    default: false
  }
})

const mobileMenuOpen = ref(false)

// Links directos a paginas dedicadas
// Nota: /services redirige a /pricing (consolidación ADR-032)
const navLinks = [
  { label: 'Precios', to: '/pricing' },
  { label: 'Cómo funciona', to: '/como-funciona' },
  { label: 'Quiénes somos', to: '/quienes-somos' },
  { label: 'Blog', to: '/blog' },
  { label: 'FAQ', to: '/centro-ayuda' }
]
</script>

<template>
  <header class="fixed top-0 left-0 right-0 z-50">
    <div class="max-w-7xl mx-auto px-6 py-4">
      <nav class="flex items-center justify-between bg-white/80 backdrop-blur-lg rounded-full px-6 py-3 border border-slate-200 shadow-sm">
        <!-- Logo -->
        <RouterLink to="/" class="flex items-center gap-2">
          <div class="w-9 h-9 bg-gradient-to-br from-accent-500 to-accent-400 rounded-xl flex items-center justify-center">
            <ShieldCheckIcon class="w-5 h-5 text-white" />
          </div>
          <span class="font-bold text-xl text-text-primary">Olvidadme</span>
        </RouterLink>

        <!-- Navigation Links (Desktop) -->
        <div class="hidden md:flex items-center gap-1">
          <RouterLink
            v-for="link in navLinks"
            :key="link.to"
            :to="link.to"
            class="px-4 py-2 text-text-secondary hover:text-text-primary hover:bg-slate-100 rounded-full transition-all font-medium text-sm"
          >
            {{ link.label }}
          </RouterLink>
        </div>

        <!-- CTA Buttons (Desktop) -->
        <div class="hidden sm:flex items-center gap-2">
          <RouterLink
            to="/auth/login"
            class="px-4 py-2 text-text-secondary hover:text-text-primary transition-colors font-medium text-sm"
          >
            Acceder
          </RouterLink>
          <RouterLink
            to="/auth/register"
            class="px-5 py-2.5 bg-gradient-to-r from-accent-600 to-accent-500 text-white font-semibold rounded-full hover:shadow-lg hover:shadow-accent-500/25 transition-all text-sm cursor-pointer"
          >
            Empezar ahora
          </RouterLink>
        </div>

        <!-- Mobile Menu Button -->
        <button
          class="md:hidden p-2 text-text-secondary hover:text-text-primary hover:bg-slate-100 rounded-full transition-colors cursor-pointer"
          @click="mobileMenuOpen = !mobileMenuOpen"
          :aria-label="mobileMenuOpen ? 'Cerrar menu' : 'Abrir menu'"
        >
          <XMarkIcon v-if="mobileMenuOpen" class="w-6 h-6" />
          <Bars3Icon v-else class="w-6 h-6" />
        </button>
      </nav>

      <!-- Mobile Menu -->
      <Transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0 -translate-y-2"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 -translate-y-2"
      >
        <div
          v-if="mobileMenuOpen"
          class="md:hidden mt-2 bg-white/95 backdrop-blur-lg rounded-2xl border border-slate-200 shadow-lg p-4"
        >
          <div class="flex flex-col gap-1">
            <RouterLink
              v-for="link in navLinks"
              :key="link.to"
              :to="link.to"
              class="px-4 py-3 text-text-secondary hover:text-text-primary hover:bg-slate-100 rounded-xl transition-all font-medium"
              @click="mobileMenuOpen = false"
            >
              {{ link.label }}
            </RouterLink>
            <hr class="my-2 border-slate-200">
            <RouterLink
              to="/auth/login"
              class="px-4 py-3 text-text-secondary hover:text-text-primary hover:bg-slate-100 rounded-xl transition-all font-medium text-center"
              @click="mobileMenuOpen = false"
            >
              Acceder
            </RouterLink>
            <RouterLink
              to="/auth/register"
              class="px-4 py-3 bg-gradient-to-r from-accent-600 to-accent-500 text-white font-semibold rounded-xl hover:shadow-lg transition-all text-center cursor-pointer"
              @click="mobileMenuOpen = false"
            >
              Empezar ahora
            </RouterLink>
          </div>
        </div>
      </Transition>
    </div>
  </header>
</template>
